import _config from "../../config/dev";
import _constant from "./constants";
import { isNumber, formatDate, getKey, numberWithoutCommas } from "./utility";
import { get } from "../utils/cache";

// Mock APP_DATA to start application
// if (typeof window !== "undefined" && ENV === "dev") {
//   require("../../mock-app-data");
// }

const _parsePaymentFormData = input => {
  if (input) {
    input.partialAmountData = {
      isPartialPayment: getKey(input, "isPartialPayment", false),
      paidAmount: isAmountZero(getKey(input, "paidAmount", "")),
      blockAmount: isAmountZero(getKey(input, "blockAmount", "")),
      payableAmount: isAmountZero(getKey(input, "payableAmount", "")),
      totalAmount: isAmountZero(getKey(input, "amount", "")),
      partialLinkPayments: getKey(input, "partialLinkPayments", [])
    };
  }
  if (input && input.fields) {
    const { fields } = input;
    // fields other than amount
    let parsedFields = fields.filter(
      item =>
        !item.type ||
        (item.type !== _constant.CUSTOM_AMOUNT_MERCHANT &&
          item.type !== _constant.CUSTOM_AMOUNT_FLEXIBLE &&
          item.type !== _constant.CUSTOM_AMOUNT_QUANTATIVE)
    );
    // fields wiht amount
    parsedFields = parsedFields.concat(
      fields.filter(
        item =>
          (item.type && item.type === _constant.CUSTOM_AMOUNT_MERCHANT) ||
          item.type === _constant.CUSTOM_AMOUNT_FLEXIBLE ||
          item.type === _constant.CUSTOM_AMOUNT_QUANTATIVE
      )
    );
    input.fields = flattenFields(parsedFields, input);
  }
  return input;
};

const parseHeaderData = input => {
  const data = {};
  const isZeroAmount = Number(input.upfrontTxnAmount) === 0;
  data.upFrontAmount = input.upfrontTxnAmount;
  data.isZeroAmount = isZeroAmount;
  data.payableAmount = isZeroAmount ? _constant.SUBS_MIN_AMOUNT : input.upfrontTxnAmount;
  data.nextBilling = input.nextRenewalDate;
  data.merchantName = input.merchantName;
  data.mid = input.mid;
  data.logoURL = input.merchantLogoUrl;
  data.linkId = input.linkId;
  data.expiredDate = input.subscriptionEndDate;
  data.cancelledDate = input.subscriptioncancelledDate;
  data.closedDate = input.subscriptionClosedDate;
  data.linkName = input.linkName;
  return data;
};

const parseSubscriptionData = input => {
  const data = {};
  data.name = input.customerName;
  data.mobile = input.customerPhoneNo;
  data.email = input.customerEmail;
  data.planName = input.planName;
  data.planDescription = input.linkDescription;
  data.frequency = input.frequencyUnit;
  data.nextBilling = input.nextRenewalDate;
  data.subsStartDate = input.subscriptionStartDate;
  data.endDate = input.subscriptionEndDate;
  data.upFrontAmount = input.upfrontTxnAmount;
  data.planAmount = input.amountType === _constant.AMOUNT_FIXED ? input.renewalAmount : input.maxAmount;
  data.renewalAmount = input.amountType === _constant.AMOUNT_VARIABLE ? input.maxAmount : input.renewalAmount;
  data.merchantPreferenceInfos = input.merchantPreferenceInfos;
  data.amountType = input.amountType;
  data.subscriptionStatus = input.subscriptionStatus;
  data.paymentHistory = parsePaymentData(input.paymentDetails);
  data.trialPeriod = input.trialPeriod; // Number(input.trialPeriod);
  data.merchantDetails = { name: input.merchantName, mobile: input.merchantPhoneNo, email: input.merchantEmail };
  data.subsId = input.subscriptionId;
  return data;
};

const parseSubscriptionAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));
  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  const paymentDetails = getKey(appData, "paymentDetails", []);
  for (let i = 0; i < paymentDetails.length; i++) {
    delete paymentDetails[i].customerMobileNo;
    delete paymentDetails[i].customerEmailId;
    delete paymentDetails[i].cardNo;
  }
  return appData;
};

const parseFormAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));

  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  delete appData.fields;

  return appData;
};

const parsePaymentPagesData = input => {
  const appData = JSON.parse(JSON.stringify(input));
  appData.mid = input.mid;
  appData.linkId = input.linkId;
  return appData;
};

const parseInvoiceAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));

  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  delete appData.invoiceEmail;
  delete appData.invoicePhoneNo;

  return appData;
};

const parsePaymentPageInvoiceAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));

  delete appData.userEmailId;
  delete appData.userMobileNo;
  delete appData.userName;
  delete appData.userDefinedFields;
  delete appData.userId;

  if (appData.paymentPage) {
    delete appData.paymentPage.merchantEmail;
    delete appData.paymentPage.merchantMobile;
    delete appData.paymentPage.merchantAddress;
  }

  // if (appData.paymentFormData) {
  //   delete appData.paymentFormData.merchantEmail;
  //   delete appData.paymentFormData.merchantMobile;
  //   delete appData.paymentFormData.merchantAddress;
  // }

  return appData;
};

const parseLinkAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));

  delete appData.bindMobile;

  return appData;
};

const parsePaymentData = data => {
  if (getKey(data, "length", 0)) {
    return data.map(item => {
      return { amount: item.txnAmount, status: item.status, date: item.timeStamp };
    });
  }
  return [];
};

let flattenFields = (fields, input, parentField = "") => {
  let flatenArray = [];
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    if (field.hasOwnProperty("helpText") && field.helpText) {
      field.subText = field.helpText;
    }
    // check for Amount field
    if (field.hasOwnProperty("name") && field.name && field.name === "txnAmount") {
      field.type = _constant.CUSTOM_AMOUNT;
    }
    if (
      field.hasOwnProperty("type") &&
      field.type === _constant.CUSTOM_AMOUNT_MERCHANT &&
      getKey(input, "partialAmountData.isPartialPayment", false)
    ) {
      field.type = _constant.CUSTOM_AMOUNT_PARTIAL;
    }
    if (parentField) {
      field.parentField = parentField;
    }
    if (field.fields) {
      const parentFieldName = field.name ? field.name : "";
      flatenArray = flatenArray.concat(flattenFields(field.fields, input, parentFieldName));
      if (field.subText) {
        flatenArray[flatenArray.length - 1].parentSubText = field.subText;
      }
    } else {
      flatenArray.push(parseField(field, input));
    }
  }
  return flatenArray;
};

let parseField = (field, input) => {
  field.placeholder = field.displayText ? field.displayText : field.name;
  field.placeholder = field.mandatory ? `${field.placeholder}*` : field.placeholder;
  field.isError = false;
  field.errorName = "";
  field.inputValue = "";
  field.subText = field.subText || "";
  if (field.type) {
    customField(field, input);
  }
  return field;
};

let customField = (field, input) => {
  switch (field.type) {
    case _constant.CUSTOM_TEXT:
      textField(field);
      break;
    case _constant.CUSTOM_NUMBER:
      numberField(field);
      break;
    case _constant.CUSTOM_DROPDOWN:
      dropDownField(field);
      break;
    case _constant.CUSTOM_AMOUNT_DROPDOWN:
      dropDownAmountField(field);
      break;
    case _constant.CUSTOM_DATE:
      dateField(field);
      break;
    case _constant.CUSTOM_AMOUNT:
      textField(field);
      break;
    case _constant.CUSTOM_AMOUNT_MERCHANT:
      numberField(field);
      break;
    case _constant.CUSTOM_AMOUNT_PARTIAL:
      partialAmountField(field, input);
      break;
    case _constant.CUSTOM_AMOUNT_QUANTATIVE:
      quantityAmountField(field);
      break;
    case _constant.CUSTOM_MOBILE_NUMBER:
      textField(field);
      break;
  }
};

const _setPostPaymentFormData = fields => {
  const parsedFields = [];
  fields.forEach(element => {
    const item = {};
    item.name = element.name ? element.name : "";
    item.value = element.inputValue ? element.inputValue : "";
    if (element.parentField) {
      const index = checkElementDoesExist(parsedFields, element.parentField);
      if (index > -1) {
        parsedFields[index].fields.push(item);
      } else {
        parsedFields.push({ name: element.parentField, fields: [item] });
      }
    } else {
      parsedFields.push(item);
    }
  });
  return parsedFields;
};
let checkElementDoesExist = (parsedFields, parentField) => {
  return parsedFields.findIndex(({ name }) => name == parentField);
};
let dateField = field => {
  if (field.constraints && field.constraints.afterTransaction) {
    field.constraints.minValue = formatDate(`DD${_constant.DATE_ORDINAL}MM${_constant.DATE_ORDINAL}YYYY`, new Date());
  }
  if (field.constraints && field.constraints.beforeTransaction) {
    field.constraints.maxValue = formatDate(`DD${_constant.DATE_ORDINAL}MM${_constant.DATE_ORDINAL}YYYY`, new Date());
  }
  validationValues(field, _constant.DATE_VALIDATION, field.mandatory ? field.mandatory : false);
};
let dropDownField = field => {
  validationValues(field, _constant.LIST_VALIDATION, field.mandatory ? field.mandatory : false);
  const allowedValues = getKey(field, "constraints.allowedValues", null);
  if (allowedValues) {
    field.constraints.allowedValues = [field.name, ...allowedValues];
  }
};
let dropDownAmountField = field => {
  validationValues(field, _constant.LIST_VALIDATION, field.mandatory ? field.mandatory : false);
  const allowedValues = getKey(field, "constraints.allowedValues", null);
  if (allowedValues) {
    field.constraints.allowedValues = [{ name: field.name, value: "" }, ...allowedValues];
  }
};
let textField = field => {
  validationValues(field, _constant.TEXT_VALIDATION, field.mandatory ? field.mandatory : false);
};

let numberField = field => {
  validationValues(field, _constant.NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
let quantityAmountField = field => {
  if (field.constraints) {
    field.constraints.minValue = field.constraints.minQuantity ? field.constraints.minQuantity : "";
    field.constraints.maxValue = field.constraints.maxQuantity ? field.constraints.maxQuantity : "";
  }
  validationValues(field, _constant.NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
let validationValues = (field, type, mandatory) => {
  field.constraints[_constant.MANDATORY_VALIDATION] = mandatory;
  field.constraints.validationType = type;
};
let partialAmountField = (field, input) => {
  const maxValue = getKey(input, "partialAmountData.payableAmount", "");
  if (field.constraints && maxValue) {
    field.constraints.maxValue = maxValue;
  }
  validationValues(field, _constant.NUMBER_VALIDATION, field.mandatory ? field.mandatory : false);
};
export const validateAmountMobile = event => {
  if (event && event.target) {
    const amt = event.target.value;
    if (amt === "." || amt === "0") {
      event.target.value = "";
      return false;
    }
  } else {
    return false;
  }
};

export const validateAmountWeb = event => {
  if (!event) return false;
  if (isNumber(event) || event.keyCode === 190) {
    if (!event.target.value && (String.fromCharCode(event.which) == "0" || event.keyCode === 190)) {
      return false;
    }
    if (event.keyCode === 9) return true;

    return true;
  }
  return false;
};

export const showRupee = (event, isDesktop) => {
  if (isDesktop) {
    if (event.keyCode === 8) {
      if (event && event.target.value.length > 1) {
        return true;
      }
      return false;
    }
    if (event && (event.target.value + event.key).length > 0) {
      return true;
    }
    return false;
  }
  if (event && event.target && event.target.value && event.target.value.length > 0) {
    return true;
  }
  return false;
};

export const preventDefault = event => {
  event.preventDefault();
  event.stopPropagation();
  return false;
};
const _isNullOrUndefined = val => {
  return val === undefined || val === null;
};

const _redirectToURL = url => {
  if (url) {
    if (typeof window !== "undefined") {
      window.location.href = url;
    }
  }
};

const _getStaticPath = () => {
  let _url = STATIC_HOST;

  try {
    if (typeof window !== "undefined") {
      if (PROD) {
        _url += `/${LINK}/${VERSION}/${PLATFORM}`;
      }
    }
  } catch (e) {}
  return _url;
};

const _getAPIHOST = () => {
  if (API_HOST) {
    return _constant.BASE_URL + API_HOST;
  }
  return "";
};

const _getAPIHOSTForAOA = () => {
  if (API_HOST_AOA) {
    return API_HOST_AOA;
  }
  return "";
};

const _getAmountFieldFirtsIndex = options => {
  let item;
  let firstIndex = -1;
  for (let index = 0; index < options.length; index++) {
    item = options[index];
    if (
      item.type === _constant.CUSTOM_AMOUNT_QUANTATIVE ||
      item.type === _constant.CUSTOM_AMOUNT_MERCHANT ||
      item.type === _constant.CUSTOM_AMOUNT_FLEXIBLE ||
      item.type === _constant.CUSTOM_AMOUNT_PARTIAL ||
      item.type === _constant.CUSTOM_AMOUNT_DROPDOWN
    ) {
      firstIndex = index;
      break;
    }
  }
  return firstIndex;
};

const addClassOnBody = newClass => {
  if (document.body.className.indexOf(newClass) == -1)
    document.body.className = `${document.body.className} ${newClass}`;
};
const removeClassFromBody = newClass => {
  if (document.body.className.indexOf(newClass) > -1)
    document.body.className = document.body.className.replace(` ${newClass}`, "");
};

const isAmountZero = amt => {
  amt = numberWithoutCommas(amt);
  if (!Number(amt) || isNaN(amt)) {
    return "";
  }
  return Number(amt).toString();
};

const isWebView = () => {
  const userAgent = window.navigator && window.navigator.userAgent;
  /* Check for Safari Web View */
  const isSafariWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  if (
    isSafariWebView ||
    /wv/i.test(userAgent) ||
    (!/UCBrowser/g.test(userAgent) &&
      (/version\/[0-9].[0-9]/i.test(userAgent) && /Chrome\/\d*.\d*.\d*.\d*/i.test(userAgent)))
  ) {
    return true;
  }
  return false;
};

const invokeCheckoutJS = config => {
  console.log("invokeCheckoutJS");
  return new Promise((resolve, reject) => {
    if (window.Paytm && window.Paytm.CheckoutJS) {
      window.Paytm.CheckoutJS.init(config)
        .then(function onSuccess() {
          // after successfully updating configuration, invoke JS Checkout
          window.Paytm.CheckoutJS.invoke();
          resolve(true);
        })
        .catch(function onError(error) {
          console.log("error => ", error);
          reject(error);
        });
    }
  });
};

const setupCheckoutJS = (host, mid) => {
  let hostCheckoutJS = `${host}/merchantpgpui/checkoutjs`;
  const isAOAFlow = get(_constant.IS_AOA_FLOW);
  if (isAOAFlow) {
    hostCheckoutJS = `${_getAPIHOSTForAOA()}/merchantpgpui/checkoutjs/aoa`;
  }
  const src = `${hostCheckoutJS}/merchants/${mid}.js`;
  const script = document.createElement("script");
  script.crossOrigin = "anonymous";
  script.src = src;
  script.type = "application/javascript";
  document.body.appendChild(script);
  return script;
};

export function checkMerchantPreference(prefType, data, defaultVal) {
  const preference = data && data.find(info => info.prefType === prefType);
  if (preference && preference.prefValue) {
    return preference.prefValue === "Y";
  }
  return defaultVal;
}

export default {
  parsePaymentFormData: _parsePaymentFormData,
  isNullOrUndefined: _isNullOrUndefined,
  redirectToURL: _redirectToURL,
  getStaticPath: _getStaticPath,
  setPostPaymentFormData: _setPostPaymentFormData,
  getAPIHOST: _getAPIHOST,
  getAPIHOSTForAOA: _getAPIHOSTForAOA,
  getAmountFieldFirtsIndex: _getAmountFieldFirtsIndex,
  addClassOnBody,
  removeClassFromBody,
  parseSubscriptionData,
  parseHeaderData,
  parsePaymentPagesData,
  parseSubscriptionAppData,
  isWebView,
  invokeCheckoutJS,
  setupCheckoutJS,
  parseFormAppData,
  parseInvoiceAppData,
  parseLinkAppData,
  parsePaymentPageInvoiceAppData
};



// WEBPACK FOOTER //
// ./utils/common.js